import { Component } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';

@Component({
    selector: 'app-confirmacao-validacao',
    templateUrl: './confirmacao-validacao.component.html',
    styleUrls: ['./confirmacao-validacao.component.scss']
})
export class ConfirmacaoValidacaoComponent {

    opcoes: Array<any>;
    situacaoSelecionada: any = null;
    mensagem: string;

    constructor(
        private navParams: NavParams,
        private modalCtrl: ModalController
    ) {
        this.opcoes = this.navParams.get('opcoes');
        this.mensagem = this.navParams.get('mensagem');
    }

    fecharClicked() {
        this.modalCtrl.dismiss();
    }

    async confirmar() {
        await this.modalCtrl.dismiss(this.situacaoSelecionada);
    }

}
